module.exports = __webpack_public_path__ + "static/media/blurred-solution.878123be.png";